import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export interface BlogPost {
  id: string
  slug: string
  title: string
  description: string
  content: string
  image_url?: string
  author_id?: string
  published: boolean
  published_at?: string
  created_at: string
  updated_at: string
  meta_title?: string
  meta_description?: string
  keywords?: string[]
}

export async function getBlogPosts(limit?: number) {
  try {
    const query = supabase
      .from('blog_posts')
      .select('*')
      .eq('published', true)
      .order('created_at', { ascending: false })

    if (limit) {
      query.limit(limit)
    }

    const { data, error } = await query

    if (error) {
      console.error('Error fetching blog posts:', error)
      return []
    }

    return data as BlogPost[]
  } catch (error) {
    console.error('Error fetching blog posts:', error)
    return []
  }
}

export async function getBlogPost(slug: string) {
  try {
    const { data, error } = await supabase
      .from('blog_posts')
      .select('*')
      .eq('slug', slug)
      .eq('published', true)
      .single()

    if (error) {
      console.error('Error fetching blog post:', error)
      return null
    }

    return data as BlogPost
  } catch (error) {
    console.error('Error fetching blog post:', error)
    return null
  }
}

export async function getRecentBlogPosts(limit = 3) {
  return getBlogPosts(limit)
}